<template>
  <div>
    <b-modal ref="modal" size="lg" lazy hide-footer>
      <unpaid-sale-orders ref="unpaid_sale_orders" :saleOrderDueDate="selectedSaleOrderDueDate"></unpaid-sale-orders>
    </b-modal>
    <Loader no-axios>
      <div v-if="!lodash.isEmpty(filterColumns)" class="row">
        <!-- <model-filter
          v-model="filter"
          :columns="filterColumns"
          :modelVariable="modelVariable"
          :filterHandler="filterHandler"
        /> -->
      </div>
      <div class="row">
        <model-index
          ref="table"
          class="col-12"
          :loading="loading"
          v-bind="$props"
          :columns="columns"
          :busy.sync="busy"
          :models-paginated="modelsPaginated"
          :page.sync="page"
          :per-page.sync="perPage"
          :from="from"
          :total="totalFiltered"
          :search.sync="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter-params.sync="filterParams"
          @create-click="handleCreate"
          @export-click="handleExport"
          @show-click="handleShow"
          @edit-click="handleEdit"
          @delete-click="handleDelete"
        >
          <template #card-title="{}">
            <div class="d-flex justify-content-between align-items-end">
              <div class="text-lg text-neutral-default">
                {{ lodash.startCase($t("account_receivable_trends.plural")) }}
              </div>
              <b-form-group
                :label="lodash.startCase($t('account_receivable_trends.day_until_due'))"
                label-class="text-block text-sm text-semibold"
              >
                <b-form-select v-model="saleOrderDueDate" :options="dayUntilDueOptions" @change="dayUntilDueChanged"></b-form-select>
              </b-form-group>
            </div>
          </template>
          <template #before-table>
            <span class="d-none"></span>
          </template>
        </model-index>
      </div>
    </Loader>
  </div>
</template>
<script>
// import ModelFilter from "@/components/model-filter-v4";
import ModelIndex from "@/router/views/models/index-v3";
import icons from "@/assets/icons";
import UnpaidSaleOrders from "./../unpaid_sale_orders";

export default {
  extends: ModelIndex,
  components: {
    // ModelFilter
    UnpaidSaleOrders
  },
  props: {
    // cardTitle: {default() { return this.lodash.startCase(this.$t('trips.plural')) }},
    resourceRoute: { default: "account_receivable_trends" },
    modelVariable: { default: "account_receivable_trend" },
    denyCreate: {
      type: Boolean,
      default: true
    },
    hideTableHeader: {
      type: Boolean,
      default: true
    },
    tableMinHeight: {
      type: Number,
      default: 0
    },
    queryKey: {
      type: String,
      default: "account_receivable_trends"
    },
    modelKey: {
      type: String,
      default: "date"
    }
  },
  data() {
    return {
      saleOrderDueDate: null,
      icons,
      dayUntilDueOptions: [
        { value: null, text: `Seluruh Transaksi` },
        { value: "0,10", text: `0-10 ${this.lodash.startCase(this.$t("units.days"))}` },
        { value: "11,20", text: `11-20 ${this.lodash.startCase(this.$t("units.days"))}` },
        { value: "21,30", text: `21-30 ${this.lodash.startCase(this.$t("units.days"))}` },
        { value: "31,40", text: `31-40 ${this.lodash.startCase(this.$t("units.days"))}` },
        { value: "0,40", text: `0-40 ${this.lodash.startCase(this.$t("units.days"))}` }
      ],
      selectedDayUntilDue: null,
      title: this.lodash.startCase(this.$t("account_receivable_trends.plural")),
      items: [
        {
          text: this.lodash.startCase(this.$t("account_receivable_trends.plural")),
          href: "/account_receivable_trends",
          active: true
        }
      ],
      sortBy: "date",
      sortDesc: false,
      filterColumns: {
        "ticketable.ticket_id__in": {
          type: Array,
          label: this.lodash.upperFirst(this.$t("tickets.ticket_id")),
          operator: "in",
          input_component: "ticket-multiselect-ajax"
        },
        day_until_due_date__between: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("account_receivable_trends.date")),
          operator: "between",
          input_component: "datepicker-range"
        }
        // day_until_due__between: {
        //   type: Array,
        //   operator: "between",
        //   input_component: "datepicker-range"
        // }
      }
    };
  },
  computed: {
    columns() {
      return {
        ["account_receivable_trend"]: [
          {
            key: "index",
            label: "No",
            tdClass: "align-middle"
          },
          {
            key: "date",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.date`)),
            tdClass: "align-middle",
            formatter: value => {
              return this.$moment(value).format("DD MMMM YYYY");
            }
          },
          {
            key: "account_receivable",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.total`)),
            tdClass: "align-middle text-end",
            formatter: value => {
              return this.$numeral(value).format("$ 0,0.[00]");
            }
          },
          {
            key: "count",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.count`)),
            thStyle: {
              width: "200px",
            },
            tdClass: "align-middle text-end",
            thClass: "text-end"
          },
          {
            key: "day_until_due_date",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.day_until_due`)),
            tdClass: "align-middle",
            component: {
              props: ["item"],
              computed: {
                badgeClass() {
                  const thresholds = [
                    { limit: 10, class: "badge-soft-red-500" },
                    { limit: 20, class: "badge-soft-yellow-500" },
                    { limit: 30, class: "badge-soft-blue-500" }
                  ];

                  for (let i = 0; i < thresholds.length; i++) {
                    if (this.item.day_until_due_date <= thresholds[i].limit) {
                      return thresholds[i].class;
                    }
                  }

                  return "badge-soft-teal-500";
                }
              },
              template: `
                <div :class="['badge rounded-pill', badgeClass]">
                  <span v-if="item.day_until_due_date === 0">Tenggat waktu hari ini</span>
                  <span v-else>Tenggat waktu {{item.day_until_due_date}} hari</span>                  
                </div>
              `
            }
          },
          {
            key: "act",
            label: this.lodash.startCase("aksi"),
            tdClass: "align-middle",
            component: {
              props: ["item"],
              methods: {
                onButtonClick(event){
                  event.stopPropagation()
                },
              },
              template: `
                <div>
                  <b-btn class="p-0" variant="link" @click="$emit('show', item)">
                    Detail
                  </b-btn>
                </div>
              `,              
            },
            componentListeners: {
              show: (item) => {
                this.handleShow(item)
              }
            }
          }
        ]
      };
    }
  },
  methods: {
    dayUntilDueChanged(value) {
      this.queryUpdate({
        day_until_due_date__between: value
      });
    },
    handleShow(value) {
      this.selectedSaleOrderDueDate = this.getModelKey(value);
      this.$refs.modal.title = `Detail Projection ${this.$moment(this.getModelKey(value)).format("DD MMMM YYYY")}`;
      this.$refs.modal.show();
    },
    requestConfig(page = 1) {
      return {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
          ...this.filterParams
        }
      };
    },
    dummyFetch() {
      return new Promise(resolve => {
        setTimeout(() => {
          const data = [
            {
              date: "2023-11-3",
              total: 1000000,
              count: 3
            },
            {
              date: "2023-11-12",
              total: 500000,
              count: 2
            },
            {
              date: "2023-11-13",
              total: 20000,
              count: 1
            },
            {
              date: "2023-11-23",
              total: 20000,
              count: 1
            },
            {
              date: "2023-12-01",
              total: 20000,
              count: 1
            },
            {
              date: "2023-12-21",
              total: 20000,
              count: 1
            }
          ];
          data.forEach(item => {
            item.day_until_due = this.$moment(item.date).diff(this.$moment(), "days");
          });
          resolve({
            data: {
              data,
              meta: {
                current_page: 1,
                from: 1,
                last_page: 280,
                per_page: "10",
                to: 10,
                total: 2796
              }
            }
          });
        }, 5000);
      });
    },
    fetchModels(page = 1) {
      this.loading = true;
      const today = this.$moment().format("YYYY-MM-DD");
      return this.$axios
        .get(`/account_receivable_projections?sort=date&date__gte=${today}`, this.requestConfig(page))
        .then(this.handleResponse)
        .catch(error => {
          this.failedAlert(error);
          return null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleResponse(response) {
      const {
        data: { data, meta }
      } = response;
      this.models = data;
      this.page = Number(meta.current_page);
      this.perPage = Number(meta.per_page);
      this.from = Number(meta.from);
      this.total = Number(meta.total);

      this.stats = [];

      return response;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/design/app";

::v-deep {
  .table-model {
    @extend .jds-table;
    table {
      @extend .table-zebra;
      @extend .table-borderless;
    }
  }
}
</style>
